import { render, staticRenderFns } from "./SpText.vue?vue&type=template&id=0c01a42d&scoped=true"
import script from "./SpText.vue?vue&type=script&lang=js"
export * from "./SpText.vue?vue&type=script&lang=js"
import style0 from "./SpText.vue?vue&type=style&index=0&id=0c01a42d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c01a42d",
  null
  
)

export default component.exports